import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { LoadingScreen } from 'scenes/Dashboard/components-next/Loading'
import { Redirect, Route, Switch } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent } from '@mui/material'

import { USER_MANAGER_DETAILS_PATH } from '../../UserManager.routes'
import { getUserDetailsFormDataPath, USER_MANAGER_DETAILS_FORM_DATA_PATH } from './UserDetailsView.routes'
import { useUserDetailsViewStore } from './UserDetailsView.store'
import { UserDetailsFormView } from './scenes/UserDetailsFormView'

export type UserDetailsViewContentProps = ExtendableStyles & Testable

export function UserDetailsViewContent({ className, style, ...otherProps }: UserDetailsViewContentProps) {
  const {
    state: { userId },
  } = useUserDetailsViewStore()
  return (
    <section className={className}>
      <CardContent {...otherProps}>
        <Suspense fallback={<LoadingScreen />}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Switch>
              <Route path={USER_MANAGER_DETAILS_PATH} exact>
                <Redirect to={getUserDetailsFormDataPath(userId)} />
              </Route>
              <Route path={USER_MANAGER_DETAILS_FORM_DATA_PATH} component={UserDetailsFormView} exact />
            </Switch>
          </ErrorBoundary>
        </Suspense>
      </CardContent>
    </section>
  )
}

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <pre>{error.stack}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  )
}
